import type { Theme } from './types';

export const crtDarkTheme: Theme = {
  name: 'CRT Dark',
  id: 'crt-dark',
  colours: {
    background: {
      primary: '#0a0e14',
      secondary: '#0d1218',
      tertiary: '#11171f',
      elevated: '#161d27',
    },
    text: {
      primary: '#00ff88',
      secondary: '#00cc6a',
      tertiary: '#009950',
      inverse: '#0a0e14',
    },
    accent: {
      primary: '#00ff88',
      secondary: '#00ccff',
      success: '#00ff88',
      warning: '#ffcc00',
      error: '#ff3333',
    },
    feedback: {
      placed: '#00ff88',
      misplaced: '#ffcc00',
      incorrect: '#335544',
    },
    rarity: {
      common: '#888888',
      uncommon: '#4ade80',
      rare: '#60a5fa',
      epic: '#c084fc',
      legendary: '#fbbf24',
    },
    powerUp: {
      boost: '#2dd4bf',
      surge_i: '#f472b6',
      surge_ii: '#f472b6',
      oracle: '#ef4444',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: "'Courier New', 'Lucida Console', monospace",
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  borders: {
    radius: {
      sm: '0.125rem',
      md: '0.25rem',
      lg: '0.375rem',
      full: '9999px',
    },
    width: {
      thin: '1px',
      normal: '2px',
      thick: '3px',
    },
  },
  shadows: {
    sm: '0 0 4px rgba(0, 255, 136, 0.15)',
    md: '0 0 8px rgba(0, 255, 136, 0.2)',
    lg: '0 0 16px rgba(0, 255, 136, 0.25)',
    xl: '0 0 24px rgba(0, 255, 136, 0.3)',
    glow: '0 0 20px rgba(0, 255, 136, 0.4)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  scanlineAlpha: 0.08,
  vignetteEnabled: true,
  fontFamily: "'Courier New', 'Lucida Console', monospace",
  rarityColours: {
    common: '#888888',
    uncommon: '#4ade80',
    rare: '#60a5fa',
    epic: '#c084fc',
    legendary: '#fbbf24',
  },
  powerUpColours: {
    oracle: '#ef4444',
    surge: '#f472b6',
    boost: '#2dd4bf',
  },
};
